import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import linkCampaignToProjectService from 'services/link-campaign-to-project-service'
import CampaignType from 'types/campaign-type'

type UseLinkCampaignToProjectProps = {} & MutateApiHookType<CampaignType>

function useLinkCampaignToProject({
  onSuccess,
  onError,
}: UseLinkCampaignToProjectProps) {
  const queryClient = useQueryClient()
  const { mutate: fetch, isLoading: pending } = useMutation(
    linkCampaignToProjectService,
    {
      onSuccess: async (data) => {
        queryClient.invalidateQueries('/projects/{id}')
        queryClient.invalidateQueries('/projects/{id}/reports/stats')
        queryClient.invalidateQueries('/campaigns')
        onSuccess?.(data)
      },
      onError,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useLinkCampaignToProject
